module.exports = __webpack_public_path__ + "img/4-1.1ee6bea6.png";